import React from 'react'
import LoginComponent from '../components/Login'

function Login() {
  return (
    <div>
      <LoginComponent />
    </div>
  )
}

export default Login